import createIcon from '../../createIcon';

/**
 * @component @name VideocamOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNSA3TDE3LjUgMTFWNy41QzE3LjUgNi45NSAxNy4wNSA2LjUgMTYuNSA2LjVIMTAuMzJMMjEuNSAxNy42OFY3Wk0zLjc3IDIuNUwyLjUgMy43N0w1LjIzIDYuNUg0LjVDMy45NSA2LjUgMy41IDYuOTUgMy41IDcuNVYxNy41QzMuNSAxOC4wNSAzLjk1IDE4LjUgNC41IDE4LjVIMTYuNUMxNi43MSAxOC41IDE2Ljg5IDE4LjQyIDE3LjA0IDE4LjMyTDIwLjIzIDIxLjVMMjEuNSAyMC4yM0wzLjc3IDIuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VideocamOff = createIcon('VideocamOff', [
  [
    'path',
    {
      d: 'M21.5 7L17.5 11V7.5C17.5 6.95 17.05 6.5 16.5 6.5H10.32L21.5 17.68V7ZM3.77 2.5L2.5 3.77L5.23 6.5H4.5C3.95 6.5 3.5 6.95 3.5 7.5V17.5C3.5 18.05 3.95 18.5 4.5 18.5H16.5C16.71 18.5 16.89 18.42 17.04 18.32L20.23 21.5L21.5 20.23L3.77 2.5Z',
      key: '1saa8f',
    },
  ],
]);

export default VideocamOff;
